module.exports = __webpack_public_path__ + "static/Transparent_Reporting-0948e9a363d45373e362f10c76b3f5b5.png";